class AlertClass {
    constructor() {
        this.swal = null
        this.notify = null
    }

    setApp(app) {
        this.swal = app.config.globalProperties.$swal
        this.notify = app.config.globalProperties.$notify
    }

    loading(message: String | null = null) {
        this.swal?.({
            title: message || "Chargement...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
        })
    }

    close() {
        this.swal?.close()
    }

    confirm(title: String, message: String) {
        return this.swal?.({
            title: title || "Êtes-vous sûr ?",
            text: message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
        })
    }

    success(message) {
        this.swal?.({
            text: message || "Opération réussie",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "success",
        })
    }

    errorBlocking(error) {
        if (typeof error === "string")
            error = { title: "Erreur", message: error }
        this.swal?.({
            icon: "error",
            title: error?.title,
            html: error?.message,
        })
    }

    error(error) {
        this.swal?.close()
        this.swal?.({
            type: "error",
            text: error,
            position: "top right",
        })
    }
}

export const Alert = new AlertClass()
